<template>
	<div class="order-container" :class="{ cartOpen: cartOpen }">
		<header class="order-hero">
			<div class="wrapper">
				<h1 class="heading">Menu </h1>
			</div>
		</header>
		<main class="menu">
			<div class="wrapper">
				<div class="menu-nav">
					<el-dropdown :hide-on-click="true" placement="top-start" style="font-family: 'Raleway', sans-serif;font-weight: bold;font-size: 25px;" @command="setIndex">
						<span class="el-dropdown-link">
							{{ $root.categories[selectedIndex].name }} <i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="i"  v-if="category.items.length > 0 && category.items[0].price !== '0.00'"" v-for="(category, i) in $root.categories" :key="category.id"> {{category.name}}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<div class="cart-button"  @click="toggleCart">
						<i style="font-size:40px;margin-right: 14px;" class="fa fa-shopping-cart"></i>
						<div class="cart-counter" v-if="totalItems > 0">
							<span>{{ totalItems }}</span>
						</div>
					</div>
				</div>
				<div class="items">
					<ul>
						<li class="menu-item" v-for="item in $root.categories[selectedIndex].items" v-if="item.price !== '0.00'" :id="item.id" @click="viewItem(item)">
							<div class="menu-item--top" :id="item.id">
								<h3 class="tertiary-heading">{{ item.name }}</h3>
								<h4 class="tertiary-heading menu-item--price">${{ item.price }}</h4>
							</div>
							<div class="menu-item--bottom">
								<h4 class="primary-copy menu-item--desc" v-if="item.desc !== item.name">{{ item.desc }}</h4>
							</div>
						</li>
					</ul>
				</div>
				<transition name="fade">
					<item-viewer
						:selectedItem="selectedItem" 
						:viewingItem="viewingItem" 
						class="item-viewer" 
						@close="closeItem" 
						@addItem="handleAddItem"
						@addOne="incrementQty"
						@subtractOne="decrementQty">
					</item-viewer>
				</transition>
				<cart style="transition: all 0s!important"
					:class="{open: cartOpen}" 
					class="cart" 
					:cartOpen="cartOpen" 
					@close="toggleCart" 
					@edit="editItem" 
					@remove="removeItem" 
					@checkout="handleCheckout">
				</cart>
			</div>
		</main>
	</div>
</template>

<script>
	import $ from 'jquery'
	import ItemViewer from './ItemViewer'
	import Cart from './Cart'
	import ConfirmOrder from './ConfirmOrder'
	import Orders from '@/controllers/Orders'
	import global from '@/global.js'

	export default {
		name: 'Order',
		props: ['cartOpenedRemotely'],
		created () {
			if (this.cartOpenedRemotely) {
				this.cartOpen = !this.cartOpen
			}
		},
		mounted () {
			console.log(global.getLocation())
			console.log(this.$root.categories)
		},
		data () {
			return {
				dropdownOpen: false,
				selectedIndex: 0,
				selectedItem: {},
				viewingItem: false,
				cartOpen: false,
				navOpen: false,
				location: global.getLocation()
			}
		},
		computed: {
			cart () {
				return this.$root.cart
			},
			totalItems () {
				let totalItems = 0
				this.cart.forEach((item) => {
					totalItems = totalItems + item.qty
				})
				return totalItems
			},
			loggedIn () {
				return this.$root.loggedIn
			},
			itemsDisplayed () {
				if (this.selectedCategory) {
					return this.selectedCategory.items
				} else {
					return []
				}
			},
			categoryDesc () {
				let desc = ''
				if (this.itemsDisplayed) {
					this.itemsDisplayed.forEach((item) => {
						if (item.price === '0.00') {
							desc = item.desc
						}
					})
				}
				return desc
			}
		},
		methods: {
			toggleDropdown () {
				console.log('dropdown')
				this.dropdownOpen = !this.dropdownOpen
			},
			setIndex (index) {
				this.selectedIndex = index
				// this.$set(this.selectedIndex = index)
				console.log(this.selectedIndex)
			},
			viewItem (item) {
				let newItem = {
					name: item.name,
					desc: item.desc,
					price: item.price,
					id: item.id,
					qty: 1,
					edit: false
				}
				this.selectedItem = Object.assign({}, newItem)
				this.viewingItem = !this.viewingItem
			},
			incrementQty () {
				this.selectedItem.qty++
			},
			decrementQty () {
				this.selectedItem.qty--
			},
			closeItem (cameFromCart) {
				this.viewingItem = !this.viewingItem
				if (cameFromCart) {
					this.cartOpen = !this.cartOpen
				}
			},
			openItem () {
				this.viewingItem = true
			},
			handleAddItem (specialInstructions) {
				let formattedPrice = parseFloat(this.selectedItem.price).toFixed(2)
				let newItem = {
					id: this.selectedItem.id,
					name: this.selectedItem.name,
					qty: this.selectedItem.qty,
					specialInstructions,
					price: formattedPrice
				}
				this.$emit('addItem', newItem)
			},
			toggleCart () {
				$('.hamburger').toggleClass('open')
				this.cartOpen = !this.cartOpen
			},
			editItem (id) {
				this.cart.forEach((item) => {
					if (item.id === id) {
						let newItem = {
							name: item.name,
							desc: item.desc,
							price: item.price,
							id: item.id,
							qty: item.qty,
							edit: true
						}
						this.selectedItem = Object.assign({}, newItem)
					}
				})
				this.viewingItem = !this.viewingItem
				this.cartOpen = !this.cartOpen
			},
			removeItem (id) {
				this.cart.forEach((item, index) => {
					if (item.id === id) {
						this.cart.splice(index, 1)
					}
				})
			},
			handleCheckout () {
				this.checkout(this.cart)
			},
			checkout (cart) {
				if (this.$root.loggedIn && !this.$root.guest) {
					cart.forEach((item, index) => {
						let itemObj = {
							'location_id': this.location,
							'item_id': item.id,
							'item_qty': item.qty,
							'base_price': item.price,
							'actual_price': item.price,
							'item_order': 1,
							'modifiers': []
						}
						if (this.$root.cartId !== 0) {
							itemObj.cart_id = this.$root.cartId
						}
						Orders.addToCart(itemObj).then(response => {
							this.$root.cartId = response.payload.items[0].cart_id
						}).catch(e => {
							console.log('error adding item to cart')
						})
					})
					this.loadCartData()
					this.$router.push('/confirmOrder')
				} else if (this.$root.guest) {
					this.$router.push('/confirmOrder')
				} else {
					this.$router.push('/login')
				}
			},
			getCart () {
				Orders.getCart(this.$root.cartId).then(response => {
					this.$root.backendCart = response.payload.items.map((item) => {
						return {
							id: item.id,
							qty: item.item_qty,
							name: item.name,
							price: item.actual_price.toFixed(2)
						}
					})
				}).catch(e => {
					console.log('error getting cart')
				})
			},
			openNav () {
				$('.hamburger').toggleClass('open')
				this.navOpen = !this.navOpen
			},
			openHours () {
				this.$emit('openHours')
			}
		},
		components: {
			ItemViewer,
			Cart,
			ConfirmOrder
		}
	}
</script>
<style lang='scss' scoped>
	@import '../assets/css/main';
	.fa-shopping-cart:hover {
		cursor:pointer;
	}
	.order-hero {
		margin-bottom: 0;
		padding-top: 75px;
	}

	.order-container {
		min-height: calc(100vh - 200px);
		transition: all 1s;
	}

	.menu {
		position: relative;
	}

	.menu-nav {
		width: 100%;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid $secondary-color;
		position: relative;
	}

	.cart-button button {
		@include primary-font(7rem, 700);
		color: $primary-color;
		position: absolute;
		right: 0;
		top: -25%;
	}
	.cart-counter:hover{
		cursor:pointer;
	}
	.cart-counter {
		background: $primary-color;
		min-width: 3rem;
		min-height: 3rem;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		right: 0;
		top: -25%;
		span {
			font-size: 2.5rem;
			color: white;
			font-family: 'Raleway', sans-serif;
		}
	}

	.custom-dropdown {
		position: relative;
		width: 80%;
		// span {
		// 	margin-left: 5%;
		// }
	}

	.custom-dropdown.open {
		width: 100%;
	}

	.custom-dropdown--options {
		display: none;
		position: absolute;
		top: 100%;
		left: 0;
		right: 0;
		bottom: 0;
		height: 80vh;
		// height: 1111%;
		overflow-y: overlay;
		overflow-x: hidden;
	}

	.custom-dropdown.open .custom-dropdown--options {
		display: block;
	}

	.custom-dropdown--option {
		background: white;
		label {
			width: 100%;
			display: block;
			margin-bottom: 0;
			color: $secondary-color;
			transition: color .15s;
		}
		label:hover {
			color: $primary-color;
		}
		input[type='radio'] {
			display: none;
		}
	}

	.items {
		padding: 2%;
	}

	.items ul {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	
	.menu-item {
		display: flex;
		flex-direction: column;
		width: 45%;
		transition: background .25s;
		margin-bottom: -1%;
		padding: 1%;
		.tertiary-heading {
			font-size: 2.4rem;
			color: $secondary-color;
		}
		.menu-item--top {
			display: flex;
			justify-content: space-between;
			align-items: baseline;
		}
		@media (max-width: 500px) {
			width: 100%;
		}
	}

	.menu-item:hover {
		background: lighten(grey, 20%);
		cursor:pointer;
	}

	.cart {
		position: fixed;
		top: 0;
		bottom: 0;
		right: 0;
		left: 100%;
		transition: all 1s;
	}
	
	.cart.open {
		position: fixed;
		width: 100%;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}

	.el-dropdown-menu__item{
		font-size: 20px !important;
		font-family: 'Raleway', sans-serif
	}
	.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
		background-color: white;
		box-shadow: 0 -4px 0 #D00016 inset;
		color: #D00016;
	}
</style>



// WEBPACK FOOTER //
// src/components/Order.vue